import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecurringsettingssimplifiinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M11 21.004H5.996a3 3 0 0 1-3-3.001V5.998a3 3 0 0 1 3-3.002h12.006a3 3 0 0 1 3 3.002V11m-1.417 5.27h1.418v-1.415m-4.582 4.478h-1.415v1.416"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M21.004 18.869c-.15.451-.401.862-.736 1.2a3.2 3.2 0 0 1-4.527 0 3.2 3.2 0 0 1-.548-.732m5.623-3.067a3.2 3.2 0 0 0-5.075-.733 3.1 3.1 0 0 0-.739 1.2m6.002-8.738H2.996M13.75 11.45a.049.049 0 1 0 0 .098.049.049 0 0 0 0-.098m-3.502 0a.05.05 0 0 0-.048.049c0 .02.012.038.03.045a.05.05 0 0 0 .054-.01.05.05 0 0 0 .01-.055.05.05 0 0 0-.046-.029m-3.501 0a.05.05 0 0 0-.036.014.05.05 0 0 0-.013.036c0 .02.012.038.03.045a.05.05 0 0 0 .054-.01.05.05 0 0 0 .01-.055.05.05 0 0 0-.046-.029m3.502 3a.05.05 0 0 0-.048.05q.001.032.03.045a.05.05 0 0 0 .054-.012.05.05 0 0 0 .01-.053.05.05 0 0 0-.046-.03m-3.501 0a.05.05 0 0 0-.036.015.05.05 0 0 0-.013.035c0 .02.012.038.03.046a.05.05 0 0 0 .054-.012.05.05 0 0 0 .01-.053.05.05 0 0 0-.046-.03m3.502 3.001a.05.05 0 0 0-.048.05q.001.032.03.045a.05.05 0 0 0 .054-.011.05.05 0 0 0 .01-.054.05.05 0 0 0-.046-.03m-3.501 0a.05.05 0 0 0-.035.014.05.05 0 0 0-.014.035.05.05 0 0 0 .03.046.05.05 0 0 0 .054-.011.049.049 0 0 0-.036-.084"
	})]
});
export default SvgRecurringsettingssimplifiinline;
